export default {
  onePrice: 'One-time price of {discPrice}',
  onePriceSuper: 'Try it out for only {discPrice}',
  price: 'Original price is {fullPrice}'
}
